import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pa-4 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_otp_input = _resolveComponent("v-otp-input")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.modal.status,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modal.status) = $event)),
      "max-width": "600",
      class: "additional-modal-wrapper",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          title: _ctx.isSign ? 'Введите код' : 'Войти'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { dense: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        (_ctx.isSign)
                          ? (_openBlock(), _createBlock(_component_v_otp_input, {
                              key: 0,
                              length: _ctx.otpLength,
                              modelValue: _ctx.submitData.code,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.submitData.code) = $event)),
                              "focus-all": "",
                              focused: "",
                              error: _ctx.submitData.code?.length !== _ctx.otpLength
                            }, null, 8, ["length", "modelValue", "error"]))
                          : (_openBlock(), _createBlock(_component_v_text_field, {
                              key: 1,
                              modelValue: _ctx.submitData.email,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.submitData.email) = $event)),
                              label: "Email*",
                              clearable: "",
                              variant: "outlined",
                              required: ""
                            }, null, 8, ["modelValue"]))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        (!_ctx.isSign)
                          ? (_openBlock(), _createBlock(_component_v_checkbox, {
                              key: 0,
                              modelValue: _ctx.privacyChecked,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.privacyChecked) = $event)),
                              color: "blue",
                              "hide-details": ""
                            }, null, 8, ["modelValue"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", {
                          class: _normalizeClass(["sign-label", { 'pl-10': _ctx.isMobile, 'pl-5': !_ctx.isMobile }])
                        }, _toDisplayString(_ctx.isSign ? _ctx.sendCodeLabel : _ctx.privacyPoliceLabel), 3)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_avatar, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeModal()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-close-circle")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (!_ctx.isSign)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      color: "blue-darken-1",
                      text: "",
                      disabled: _ctx.disabledBtn,
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.submitFunction()), ["prevent"]))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Получить код ")
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (!_ctx.privacyChecked)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 1,
                      activator: "parent",
                      location: "top"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.signBtnTooltip), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}